import {
  isEntityInstanceLink,
  type EntityInstanceLink,
} from "wombat-global/src/typings/instance-linking";
import { resolveFormValuePath } from "@wombat/anvil/core";
import { isObject } from "wombat-global/src/utilities";

// oxlint-disable-next-line typescript/no-explicit-any
export function traverseObjectPath<Value>(path: string, srcObject: any) {
  const resolvedPath = resolveFormValuePath(path, srcObject);
  if (resolvedPath === undefined) {
    return undefined;
  }

  let targetObj = srcObject;
  for (const prop of resolvedPath ? resolvedPath.split(".") : []) {
    targetObj = targetObj[prop];
  }

  if (!targetObj) {
    return targetObj;
  }

  if (Array.isArray(targetObj)) {
    return [...targetObj];
  } else if (targetObj !== null && typeof targetObj === "object") {
    // THINK: dont spread here, you lose the instantiated type? (ie, Timestamp)
    // return targetObj;
    return { ...targetObj };
  } else {
    return targetObj as Value;
  }
}

/**
 * Performs equality by checking Object.is then JSON.stringify compare
 */
export function deepEqual(objA: unknown, objB: unknown): boolean {
  if (Object.is(objA, objB)) {
    return true;
  }

  if (
    typeof objA !== "object" ||
    objA === null ||
    typeof objB !== "object" ||
    objB === null
  ) {
    return false;
  }

  return JSON.stringify(objA) === JSON.stringify(objB);
}

export const getSubFormContextLinks = (
  links: unknown,
  name: string,
): EntityInstanceLink[] => {
  let linkValues: unknown[] = [];

  if (Array.isArray(links)) {
    linkValues = links;
  } else if (isObject(links)) {
    linkValues = Object.values(links);
  }

  return linkValues.filter(
    (value): value is EntityInstanceLink =>
      isEntityInstanceLink(value) && value.meta?.linksFormPath === name,
  );
};
